class FetchHelper {
    private static headers: {[key: string]: string} = {};

    static hexEncode(str: string): string {
        let hex = "";
        for (let i = 0; i < str.length; i++) {
            hex += "" + str.charCodeAt(i).toString(16);
        }
        return hex;
    }

    static createHash(length: number) {
        const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
        let text = "";
        length = length || 6;
        for (let i = 0; i < length; i++) {
            text += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return text;
    }

    static getHeaders(url?: string, tenant?:string) {
        const jsonApiUrls = [
            "/account"
        ];
        let headers:any =  {
            ...this.headers,
            "X-B3-TraceId": this.hexEncode(this.createHash(8)),
            "X-B3-SpanId": this.hexEncode(this.createHash(8)),
            "accept": jsonApiUrls.includes(url) ? "application/json" : "*/*"
        };
        if(tenant !== undefined){
             headers = {...headers, x_tenant:tenant};
        }

        return headers;
    }
}

export default FetchHelper;